import styled, { css as scCss } from "styled-components";
import systemCss from "@styled-system/css";

import {
  color,
  layout,
  grid,
  space,
  position,
  background,
  border,
  shadow,
  typography,
  flexbox,
} from "styled-system";

export const Box = styled.div`
  position: relative;
  ${space}
  ${color}
  ${layout}
  ${background}
  ${position}
  ${grid}
  ${border}
  ${typography}
  ${flexbox}
  ${shadow}
  ${({ css }) => css && systemCss(css)}
  ${({ cursor }) =>
    cursor &&
    scCss`
      cursor: ${cursor};
    `}
  ${({ transition }) =>
    transition &&
    scCss`
        transition: ${transition};
      `}

  ${({ whiteSpace }) =>
    whiteSpace &&
    scCss`
        white-space: ${whiteSpace};
      `}
  ${({ textTransform }) =>
    textTransform &&
    scCss`
        text-transform: ${textTransform};
      `}
  ${({ transform }) =>
    transform &&
    scCss`
        transform: ${transform};
      `}
  ${({ placeItems }) =>
    placeItems &&
    scCss`
        place-items: ${placeItems};
    `}
  
  ${({ flexDirection }) =>
    flexDirection &&
    scCss`
        flex-direction: ${flexDirection};
      `}
  ${({ inset }) =>
    inset &&
    scCss`
        inset: ${inset};
      `}
  ${({ textDecoration }) =>
    textDecoration &&
    scCss`
    text-decoration: ${textDecoration};
      `}
   ${({ textTransform }) =>
    textTransform &&
    scCss`
    text-transform: ${textTransform};
      `}
  ${({ textUnderlineOffset }) =>
    textUnderlineOffset &&
    scCss`
    text-underline-offset: ${textUnderlineOffset};
      `}
   ${({ firstLetterCapital }) =>
    firstLetterCapital &&
    scCss`
      &::first-letter {
        text-transform: uppercase;
      }
    `}
  ${({ gTC }) =>
    gTC &&
    scCss`
    grid-template-columns: ${gTC};
      `}
  ${({ jC }) =>
    jC &&
    scCss`
    justify-content: ${jC};
      `}
${({ bR }) =>
    bR &&
    scCss`
    border-radius: ${bR};
      `}
${({ h }) =>
    h &&
    scCss`
    height: ${h};
      `}
${({ w }) =>
    w &&
    scCss`
    width: ${w};
      `}
${({ aI }) =>
    aI &&
    scCss`
    align-items: ${aI};
      `}
${({ gRG }) =>
    gRG &&
    scCss`
    grid-row-gap: ${gRG};
      `}

${({ gCG }) =>
    gCG &&
    scCss`
    grid-column-gap: ${gCG};
      `}
  &:hover {
    ${({ _hover }) => _hover && systemCss(_hover)}
  }
  &:focus {
    ${({ _focus }) => _focus && systemCss(_focus)}
  }
  &:active {
    ${({ _active }) => _active && systemCss(_active)}
  }
`;
